import { z } from 'zod';
import { ApprovalFlowTypeEnum } from './enums/ApprovalFlowTypeEnum';

const employeeSchema = z.object({
	employeeId: z.number(),
	name: z.string(),
});

export const approvalStepSchema = z.object({
	step: z.number(),
	approvers: z.array(employeeSchema),
});

export const approvalFlowSchema = z.object({
	id: z.number(),
	type: z.enum([ApprovalFlowTypeEnum.Regular, ApprovalFlowTypeEnum.Emergency]),
	company: z.object({
		id: z.number(),
		name: z.string(),
	}),
	board: z.object({
		id: z.number(),
		name: z.string(),
	}),
	management: z.object({
		id: z.number(),
		name: z.string(),
	}),
	requesters: z.array(employeeSchema),
	approvalSteps: z.array(approvalStepSchema),
});

export const approvalFlowListSchema = z.object({
	count: z.number(),
	nextPage: z.number().optional(),
	approvalFlows: z.array(approvalFlowSchema),
});

export enum ApprovalFlowStatus {
	ACCEPTED = 'Accepted',
	REJECTED = 'Rejected',
	PENDING = 'Pending',
	CANCELLED = 'Cancelled',
	LACK_OF_ACTION = 'LackOfAction',
}

export interface ExtraTripsPeriodDates {
	startDate: string;
	endDate: string;
}

export interface ExtraTripsCompletionDeadlines {
	[extraTripDay: string]: {
		date: string;
		expired: boolean;
	};
}

export interface ExtraTripsApproval {
	extraTripSolicitationId: number;
	employee: {
		id: number;
		name: string;
		structure?: string | undefined;
		management?: string | undefined;
		employeeNumber: string;
	};
	workStations: string[];
	dates: ExtraTripsPeriodDates[];
	reason: string;
	detailing?: string;
	completionDeadlines?: ExtraTripsCompletionDeadlines;
	status?: string;
	comment?: string | null;
	currentApprovalStep?: number;
	currentApprovalStepApprovers?: string[];
}

export const ExtraTripsApprovalSchema = z.object({
	extraTripSolicitationId: z.number(),
	employee: z.object({
		id: z.number(),
		name: z.string(),
		structure: z.string().optional(),
		management: z.string().optional(),
		employeeNumber: z.string(),
	}),
	workStations: z.array(z.string()),
	dates: z.array(
		z.object({
			startDate: z.string(),
			endDate: z.string(),
		}),
	),
	reason: z.string(),
	detailing: z.string().optional(),
	completionDeadlines: z
		.record(
			z.string(),
			z.object({
				date: z.string(),
				expired: z.boolean(),
			}),
		)
		.optional(),
	status: z.string().optional(),
	comment: z.string().nullable().optional(),
	currentApprovalStep: z.number().optional(),
	currentApprovalStepApprovers: z.array(z.string()).optional(),
});

export const ExtraTripsApprovalListSchema = z.object({
	extraTripSolicitationData: z.array(ExtraTripsApprovalSchema),
	count: z.number(),
	nextPage: z.number().optional(),
});
